var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoc = function SvgDoc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 46 62"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#doc_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 62,
    fill: "#040404",
    fillOpacity: 0.03,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3467CC",
    d: "M40.026-6.556a1 1 0 0 1 1.414 0L54.168 6.172a4 4 0 0 1 0 5.657l-4.718 4.718L33.187.283z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#doc_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 56,
    x: 3,
    y: 3,
    fill: "#fff",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 55,
    x: 3.5,
    y: 3.5,
    stroke: "#E9E9E9",
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 2,
    x: 22,
    y: 52,
    fill: "#9F9F9F",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 2,
    x: 22,
    y: 32,
    fill: "#E4E4E4",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    x: 22,
    y: 35,
    fill: "#E4E4E4",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 2,
    x: 22,
    y: 38,
    fill: "#E4E4E4",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 2,
    x: 22,
    y: 41,
    fill: "#E4E4E4",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3467CC",
    fillOpacity: 0.84,
    d: "M16 49.469v2.465H8.727v-2.515q0-1.083.437-1.86a2.9 2.9 0 0 1 1.247-1.2q.813-.42 1.946-.42 1.136 0 1.953.423.816.42 1.253 1.21.437.789.437 1.897m-1.14 1.147v-1.083q0-.76-.277-1.268a1.77 1.77 0 0 0-.834-.763q-.558-.255-1.392-.256-.835 0-1.385.256-.555.255-.828.756-.276.497-.277 1.236v1.122zm1.247-7.851q0 .799-.352 1.385-.351.586-.984.909-.632.32-1.477.32t-1.48-.32a2.4 2.4 0 0 1-.988-.91q-.351-.585-.352-1.384 0-.799.352-1.385.351-.586.987-.906.636-.323 1.481-.323t1.477.323q.633.32.984.906.351.585.351 1.385m-1.03-.007q0-.433-.238-.725a1.44 1.44 0 0 0-.646-.433 2.7 2.7 0 0 0-.902-.145q-.501 0-.906.145-.408.143-.65.433a1.1 1.1 0 0 0-.241.725q0 .444.241.738.242.292.65.437.405.142.906.142.496 0 .902-.142.405-.145.646-.437.238-.294.238-.738m1.03-5.677q0 .816-.36 1.403-.358.582-.99.898-.636.313-1.463.313-.831 0-1.467-.32a2.4 2.4 0 0 1-.994-.902q-.359-.585-.359-1.385 0-.664.245-1.175.242-.516.686-.82.44-.306 1.03-.349v1.229q-.395.075-.657.355-.267.277-.267.742 0 .394.213.693.21.298.604.465.395.163.945.163.557 0 .959-.163a1.4 1.4 0 0 0 .614-.458q.213-.298.213-.7 0-.284-.107-.508a1 1 0 0 0-.316-.38 1.2 1.2 0 0 0-.5-.209v-1.229q.579.047 1.026.341.444.295.696.803.248.507.248 1.193"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "doc_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 62,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "doc_svg__b",
    width: 42,
    height: 58,
    x: 2,
    y: 3,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_532_1399"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_532_1399",
    result: "shape"
  })))));
};
export default SvgDoc;